
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.933 10.362a.856.856 0 01-.19.28l-4.115 4.1-.249.164A.794.794 0 0110 15a.888.888 0 01-.391-.094l-.237-.165-4.114-4.1a.856.856 0 010-1.225.87.87 0 011.233 0l2.631 2.615V5.87c0-.482.392-.871.878-.871a.873.873 0 01.877.872v6.16l2.632-2.615a.87.87 0 011.233 0 .856.856 0 01.19.945h.001z"}})])
          )
        }
      }
    